import { createFileRoute } from "@tanstack/react-router";
import SearchResultsPage from "~/features/search-results/_components/search-results-page.js";
import { normalizePlayerTag } from "~/features/search-filters/_utils/normalize-tag.js";

export const Route = createFileRoute("/_authed/my-players/$tag/clan-search/results")({
  component: PlayerClanSearchResultsTab,
});

function PlayerClanSearchResultsTab() {
  const { tag } = Route.useParams();
  const playerTag = normalizePlayerTag(tag);
  const auth = { playerTag };

  return <SearchResultsPage auth={auth} scope="player" />;
}
